import { render } from "./DataModal.vue?vue&type=template&id=07fbb594"
import script from "./DataModal.vue?vue&type=script&lang=js"
export * from "./DataModal.vue?vue&type=script&lang=js"

import "./DataModal.vue?vue&type=style&index=0&id=07fbb594&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__